module.exports = "/_next/static/images/icon-home-page-8b91ad91.png";